<template>
  <div class="main">
    <template v-if="!empty">
      <div class="box1">
        <div class="left" :class="ruleForm.outline_image?'':'none-img-bg'">
          <img v-if="ruleForm.outline_image" class="" :src=" this.$imgUrl(ruleForm.outline_image)" alt="">
          <img v-else class="none-img" :src="require('@/assets/images/manage/course/cr_course_defaut_icon.png')" alt="">
        </div>
        <div class="right">
          <p>
            <span class="font_weight_600">课程名称：</span>
            <span class="margin_left_5" style="color: rgb(19, 179, 231);">{{ ruleForm.outline_name }}</span>
          </p>
          <p>
            <span class="font_weight_600">发布单位：</span>
            <span class="margin_left_5">{{ ruleForm.enterprise_name }}</span>
          </p>
          <p>
            <span class="font_weight_600">创建时间：</span>
            <span class="margin_left_5">{{ ruleForm.utime_str }}</span>
          </p>
          <div class="right-row">
            <p>
              <span class="font_weight_600">线下授课：</span>
              <span class="margin_left_5">{{ ruleForm.offline_start_date }} - {{ ruleForm.offline_end_date }}</span>
            </p>
            <p>
              <span class="font_weight_600">线下培训：</span>
              <span class="margin_left_5">{{ ruleForm.offline_price }}元</span>
            </p>
          </div>
          <div class="right-row">
            <p>
              <span class="font_weight_600">线上价格：</span>
              <span class="margin_left_5">{{ ruleForm.online_price }}元</span>
            </p>
            <p>
              <span class="font_weight_600">客户购买有效期：</span>
              <span class="margin_left_5">{{ ruleForm.purchase_validity }}</span>
            </p>
          </div>
          <p>
            <el-checkbox v-model="ruleForm.offline_type" disabled>开通线下报名</el-checkbox>
          </p>
        </div>

      </div>
      <div class="box2">
        <div class="left">
          <p>
            <span class="font_weight_600">AI总分：</span>
            <span class="margin_left_5 margin_right_20">{{ ruleForm.ai_score }}分</span>
            <el-rate disabled :value="formatRate" allow-half text-color="#ff9900"></el-rate>
          </p>
        </div>
        <div class="right">
          <p>
            <span class="font_weight_600">授课讲师：</span>
            <span class="margin_left_5">{{ ruleForm.instructor }}</span>
          </p>
        </div>
      </div>
      <div class="box3">
        <div class="label" style="margin-bottom: 10px">
          <span class="font_weight_600">课程简介：</span>
        </div>
        <p class="content">
          {{ ruleForm.outline_intro }}
        </p>
      </div>
      <!-- 新增适用岗位标签展示区域 -->
      <div class="box岗位">
        <p class="label">
          <span class="font_weight_600">适用岗位：</span>
        </p>
        <div class="tags-container">
          <el-tag v-for="(item, index) in ruleForm.outline_hier_dicts" :key="index">
            {{ item.value }}
          </el-tag>
        </div>
      </div>
      <div class="box4">
        <div class="left">
          <p>
            <span class="font_weight_600">
              联系人：
            </span>
            <span class="margin_left_5">
              {{ ruleForm.contact_person }}

            </span>

          </p>
        </div>
        <div class="right">
          <p>
            <span class="font_weight_600">
              联系电话：
            </span>
            <span class="margin_left_5">
              {{ ruleForm.contact_phone }}
            </span>
          </p>
        </div>
      </div>
      <div class="box5">
        <p>
          <span class="font_weight_600">
            地 址：
          </span>
          <span class="margin_left_5">
            {{ ruleForm.contact_address }}
          </span>
        </p>
      </div>
    </template>

    <template v-else>
      <el-empty description="暂无数据" class="empty"></el-empty>
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        empty: false,
        formatObj: {
          date1: [],
          date2: [],
          education: null
        },
        ruleForm: {
          "outline_id": "",
          "outline_name": "",
          "enterprise_id": "",
          "enterprise_name": "",
          "outline_image": "",
          "offline_start_date": "",
          "offline_end_date": "",
          "ai_score": 0,
          "instructor": "",
          "outline_intro": "",
          "contact_person": "",
          "contact_phone": "",
          "contact_address": "",
          "ctime": "",
          "ctime_str": "",
          "utime": "",
          "utime_str": "",
          "deleted": 2,
          "online_price": "",
          "purchase_validity": "",
          outline_hier_dicts: [],
        },

      };
    },
    computed: {
      formatRate() {
        console.log(this.ruleForm.ai_score);
        return Number(this.ruleForm.ai_score) ? Number(this.ruleForm.ai_score) / 20 : 0
      }
    },
    methods: {
      getData(outline_id) {
        if (!outline_id) {
          this.empty = true
          return
        } else {
          this.empty = false
        }

        this.$tools
          .asyncPost(
            this,
            this.$baseUrl.trainingCourseGet, {
            data: {
              outline_id: outline_id
            }
          }).then((res) => {
            if (res.data.code == 0) {
              this.ruleForm = res.data.data
              this.ruleForm.offline_price = this.ruleForm.offline_price?.length > 0 ? parseFloat(this.ruleForm.offline_price) : 0
              this.ruleForm.offline_type = this.ruleForm.offline_type == 'true' ? true : false

            } else {
              this.$message({ type: "error", message: res.data.msg });
            }
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
          });

      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style lang="less" scoped>
  .demo-ruleForm {
    width: 100%;
    padding-right: 10px;

    .courseImage {
      // height: 100%;

      .required {
        width: 25px;
        content: '*';
        color: #F56C6C;
        text-align: right;
        margin-right: 4px;
      }

      /deep/ .el-form-item__content {
        display: flex;
        margin-left: 0 !important;

        .courseImageUpload {
          height: 184px;
          flex: 1;
          min-width: 0;

          .el-upload.el-upload--text {
            width: 100%;
            height: calc(100% - 0px);
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 100%;
            // height: 100%;
            line-height: 184px;
            text-align: center;
          }

          img {
            height: 100%;
            width: 100%;

            object-fit: cover;
          }
        }
      }
    }
  }

  // 
  .changeTopMargin {
    margin: 18px 0 0 0;
  }

  .changeMargin {
    margin: 18px 0;

    /deep/ .el-form-item {
      margin: 0px;
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .rate {
    width: 50px;

    /deep/ .el-input__inner {
      padding: 0 0 0 5px;
    }

    //

  }

  .main {
    padding: 10px;
    width: 100%;

    .empty {
      width: 100%;
      height: 100%;
    }

    .box1 {
      display: flex;
      width: 100%;

      .left {
        width: 226px;
        height: 159px;
        margin-right: 20px;
        border-radius: 6px;
        overflow: hidden;
        text-align: center;
        line-height: 159px;

        img {
          width: 100%;
          height: 100%;
          //object-fit: cover;
        }

        .none-img {
          width: 30%;
          height: 30%;
          opacity: 0.5;
        }

      }

      .none-img-bg {
        background-color: #f2f2f2;
      }

      .right {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          height: 40px;
          line-height: 40px;
        }

        .right-row {
          display: flex;
          p {
            flex: 1;
            min-width: 0;
          }
        }
      }
    }

    .box2 {
      display: flex;
      width: 100%;

      .left {
        width: 226px;

        margin-right: 20px;

        p {
          height: 40px;
          line-height: 40px;

          display: flex;
          align-items: center;
        }
      }

      .right {

        p {
          height: 40px;
          line-height: 40px;

        }
      }
    }

    .box3 {
      p.label {
        height: 40px;
        line-height: 40px;

      }

      p.content {
        text-indent: 2rem;
        line-height: 20px;
        // min-height: 160px;
        white-space: normal;
      }
    }

    .box4,
    .box5 {
      p {
        height: 40px;
        line-height: 40px;
      }
    }

    .box4 {
      display: flex;

      // width: 100%;
      .left {
        width: 400px;
        margin-right: 20px;

        p {
          height: 40px;
          line-height: 40px;


        }
      }
    }
  }

  /* 新增岗位标签样式 */
  .box岗位 {
    display: flex;
    /* 启用Flex布局 */
    align-items: center;
    /* 垂直居中对齐 */

    .label {
      height: 40px;
      line-height: 40px;
    }

    .tags-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
  }
</style>